module.exports = __webpack_public_path__ + "static/media/designbase-logo.89788c8f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/slides/Designbase/assets/designbase-logo.svg
// module id = 60
// module chunks = 0